import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { merge, Observable, of } from 'rxjs';
import { catchError, filter, switchMap } from 'rxjs/operators';

import { AuthService } from 'app/services/auth.service';
import { Loggable } from 'app/utils/logging/loggable';
import { isUndefined, notUndefined } from 'app/utils/stream-util';

/**
 * @deprecated
 *  Class-based Route guards are deprecated in favor of functional guards.
 *  An injectable class can be used as a functional guard using the
 *  inject function: canActivate: [() => inject(myGuard).canActivate()]
 */
@Injectable({ providedIn: 'root' })
export class SignInGuard extends Loggable implements CanActivate {
  private router = inject(Router);
  private authService = inject(AuthService);

  public constructor() {
    super();
    this.setDisplayName('SignInGuardService');
  }

  public canActivate(): Observable<boolean | UrlTree> {
    const signedOut$ = this.authService.user$.pipe(
      filter(isUndefined),
      switchMap(() => of(this.router.createUrlTree(['welcome']))),
    );

    const signedIn$ = this.authService.user$.pipe(
      filter(notUndefined),
      switchMap(() => {
        let navRoute = '';

        if (this.authService.isAnonymous()) {
          this.authService.signOutUser();
          navRoute = 'welcome';
        }

        return of(this.router.createUrlTree([navRoute]));
      }),
      catchError(() => {
        return of(this.router.createUrlTree(['welcome']));
      }),
    );
    return merge(signedIn$, signedOut$);
  }
}
